module.exports = __webpack_public_path__ + "static/img/logo.739006a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/logo.png
// module id = pS5Q
// module chunks = 4